/**
 * @generated SignedSource<<3c35c4d8974f67156588875a6147a7b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoreSurveysBannerRefetchQuery$variables = {};
export type MoreSurveysBannerRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMoreSurveysBannerQuery_profileUrlRef">;
};
export type MoreSurveysBannerRefetchQuery = {
  response: MoreSurveysBannerRefetchQuery$data;
  variables: MoreSurveysBannerRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MoreSurveysBannerRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useMoreSurveysBannerQuery_profileUrlRef"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MoreSurveysBannerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endlessProfilerUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demographicProfileUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profilerUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileCompletion",
        "kind": "LinkedField",
        "name": "profileCompletionPercentage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileCompletionPercentage",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "12e6d3733e57fc266496ae87ed5067f7",
    "id": null,
    "metadata": {},
    "name": "MoreSurveysBannerRefetchQuery",
    "operationKind": "query",
    "text": "query MoreSurveysBannerRefetchQuery {\n  ...useMoreSurveysBannerQuery_profileUrlRef\n}\n\nfragment useMoreSurveysBannerQuery_profileUrlRef on Query {\n  endlessProfilerUrl\n  demographicProfileUrl\n  profilerUrl\n  profileCompletionPercentage {\n    profileCompletionPercentage\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5628b6a60d13cdc2a8f94f392698f092";

export default node;
